import React from "react";
import logo from "../../img/logo.png";

export default function Footer() {
  return (
    <>
      <section className="bg-gray-900 w-full h-fit ">
        <div className=" text-white pt-8 lg:pt-10 mx-auto max-w-screen-xl px-4">
          <footer className=" pt-10 pb-5 lg:pb-10 relative z-10">
            <div className="container">
              <div className="flex flex-wrap -mx-4">
                <div className="w-full  text-center px-4">
                  <div className="w-full mb-10">
                    <a href="/" className="flex justify-center items-center mb-6">
                      <img src={logo} className="mr-3 h-6 sm:h-9" alt="Flowbite Logo"></img>
                      <span className="self-center text-xl font-semibold whitespace-nowrap text-white">PayCoLife</span>
                    </a>
                    <p className="text-base text-body-color mb-7">
                      For those who do not know how to do DropShipping, <br />
                      in the PayCoLife system, which allows them to do this automatically, <br />
                      you can catch the necessary opportunities to fix your economy without getting tired and without
                      any effort.
                      <br />
                      <br />
                      PayCoLife is My Financial Life!
                      <br />
                      <br />© 2020 PayCoLife. Component copyrights belongs to their authors.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </section>
    </>
  );
}
